/**
 * Vuex module for contact tags
 */
import debug from 'debug'

const dbg = debug('store:contacts:TagDeleteForm:')

const actions = {
  open ({ commit }, tag) {
    dbg('Open tag delete form dialog')
    if (import.meta.env.NODE_ENV === 'test') {
      return true
    }
    commit('OPEN_DIALOG', tag)
  },
  close ({ commit }) {
    dbg('Close tag delete form dialog')
    if (import.meta.env.NODE_ENV === 'test') {
      return true
    }
    commit('CLOSE_DIALOG')
  },
  setTag ({ commit }, tag) {
    commit('SET_TAG', tag)
  }
}

const mutations = {
  CLOSE_DIALOG (state) {
    state.tag = null
    state.isPersonal = false
    state.dialog = false
  },

  OPEN_DIALOG (state, tag) {
    state.dialog = true
    state.tag = tag
    state.isPersonal = tag.isPersonal
  },

  SET_TAG (state, tag) {
    state.tag = tag
  }
}

const state = {
  dialog: false,
  tag: null,
  isPersonal: false
}

const getters = {
  dialog: state => state.dialog,
  tag: state => state.tag,
  isPersonal: state => state.isPersonal
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
